import './App.css';
import NewBgc from './assets/components/NewBgc';

function App() {
  return (
    <div className="App">
      <NewBgc />
    </div>
  );
}

export default App;
